import BaseAPI from "../base";

function getHistory(cafe_id, start, end) {
  return BaseAPI.get(`sms/history`, {
      cafe_id,
      start,
      end
  });
}


export default {
  getHistory,
};